import * as React from "react";
import "./MobileBooks.css";
import { useSelector } from "react-redux";
import {
	getReadNowBooks,
	getWantReadBooks,
	getAlreadyReadBooks,
} from "../../store/calendar/selectors";
import BookSection from "./components/BooksSection/BooksSection";
import { CardsManagerCallbacks } from "../CardsManager/CardsManager";
import Button from "../Button/Button";
import FindBook from "../Header/FindBook/FindBook";
import LinearProgress from "@material-ui/core/LinearProgress";
import MobileBookSection from "./MobileBookSection/MobileBookSection";
import CategoryCard from "../CatrgoriesCardComponent/Component";
import AdBlock from "../AdBlock/AdBlock";

interface Props {
	callbacks: CardsManagerCallbacks;
}

const MobileBook: React.FC<Props> = (props) => {
	const readNowBooks = useSelector(getReadNowBooks);
	const wantReadBooks = useSelector(getWantReadBooks);
	const alreadyReadBooks = useSelector(getAlreadyReadBooks);

	const addBookButton = (add: () => void) => {
		return <Button onClick={add}>Добавить книгу</Button>;
	};

	return (
		<div className="mobile-books">
			{props.callbacks.loading && (
				<div className="mobile-book-card__loading">
					<LinearProgress />
				</div>
			)}

			<MobileBookSection>
				<CategoryCard />
			</MobileBookSection>

			<BookSection
				header="Читаю сейчас"
				type="readNow"
				books={readNowBooks}
				bookShowType="standart"
				emptyText={
					<div className="dummy">
						Добавьте в этот список книги, которые читаете прямо сейчас
						<div className="dummy__button">
							<FindBook
								dummyRender={addBookButton}
								callbacks={props.callbacks}
							/>
						</div>
					</div>
				}
			/>

			<BookSection
				header="Хочу прочитать"
				type="wantRead"
				books={wantReadBooks}
				bookShowType="mini"
				emptyText={
					<div className="dummy">
						Планируете прочитать книгу? Добавьте ее в этот список. Вы также
						можете указать дату начала чтения и тогда мы пришлем вам напоминание
						<div className="dummy__button">
							<FindBook
								dummyRender={addBookButton}
								callbacks={props.callbacks}
							/>
						</div>
					</div>
				}
			/>

			<BookSection
				header="Прочитано"
				type="alreadyRead"
				books={alreadyReadBooks}
				bookShowType="mini"
				emptyText={
					<div className="dummy">
						Добавьте книги, которые вы прочитали в бумажном или электронном
						виде.
						<div className="dummy__button">
							<FindBook
								dummyRender={addBookButton}
								callbacks={props.callbacks}
							/>
						</div>
					</div>
				}
			/>

			<AdBlock />

			{/*<MobileBookSection header="Что читают">
				<Feed callbacks={props.callbacks} />

				<div className="mobile-books-feed__showMore">
					<CollectionCard header="Показать еще" action="/list" />
				</div>
			</MobileBookSection>*/}
		</div>
	);
};

export default MobileBook;
